import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsEditStatusTsService {

  private editModeSubject= new BehaviorSubject<boolean>(false);

  constructor() { }

  setEditMode(value: boolean) {
    this.editModeSubject.next(value);
  }

  getEditModeObservable() {
    return this.editModeSubject.asObservable();
  }
}

